export const isHoverable = matchMedia("(hover:hover)").matches;
